import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(episode) {
  const keywords =
    episode?.meta_keywords && episode?.meta_keywords?.length > 0
      ? episode.meta_keywords.join(",")
      : null;
  const genre = episode?.genres?.[0]?.name || "";

  return {
    title: `${episode.name}【${genre}】の動画配信 | SPOOX(スプークス)`,
    keywords: keywords || defaultMetatags.vod.keywords,
    description: `${episode.name}の再生画面。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！月額見放題でも、1作品から購入でも楽しめます。
`,
    og: {
      type: "video.episode",
      url: `${config.host.vod}${routes.watch(episode.id)}`,
    },
    twitter: {
      card: "summary",
    },
  };
}

export default function WatchMetaTags({ episode }) {
  const props = tags(episode);
  return <MetaTags {...props} />;
}
